<template>
  <v-container class="default-layout fill-height pa-0">
    <v-row class="fill-height" justify="center">
      <v-col cols="1" v-if="loading">
        <v-progress-circular indeterminate color="primary" class="default-layout__loading" />
      </v-col>
      <template v-else>
        <v-col cols="12" class="pa-0">
          <router-view />
        </v-col>
      </template>
    </v-row>
    <v-snackbar v-model="snackbar" :color="snackbarColor" location="top right">
      {{ snackbarMessage }}
    </v-snackbar>
  </v-container>
</template>

<script setup lang="ts">
import { onMounted, provide, ref } from 'vue'

import { setApiErrorNotifier } from '@/api/apiErrorHandler'
import { useAppStore } from '@/stores/app'
import AppService from '@/services/appService'
import { roles } from '@/constants/roles'

const appStore = useAppStore()
const appService = new AppService()

const snackbar = ref<boolean>(false)
const snackbarMessage = ref()
const snackbarColor = ref()

const loading = ref(true)

const init = async () => {
  if (appStore.embedUser?.isNewUserCreated && appStore.embedUser?.brandId) {
    if (appStore.businessProfiles.length === 0 && appStore.user && appStore.portal) {
      appStore.setBusinessProfiles(
        await appService.getPortalBusinessProfiles(appStore.user.id, appStore.portal.id),
      )
    }

    appStore.setSelectedBusinessProfileId(appStore.businessProfiles[0]?.id ?? null)

    await appService.assignDivisionBrandsToClient(
      appStore.selectedBusinessProfileId,
      [appStore.embedUser.brandId.toString()],
      roles.STUNNR_BE_CLIENT_ACCESS,
    )
  }

  loading.value = false
}

const notify = (message: string, color: string) => {
  snackbar.value = true
  snackbarMessage.value = message
  snackbarColor.value = color
}

onMounted(() => {
  setApiErrorNotifier(notify)
  init()
})

provide('notify', notify)
</script>

<style scoped lang="scss">
.default-layout {
  max-height: 100vh;
  max-width: 100vw;
  overflow: hidden;
  align-items: flex-start !important;

  > .v-row {
    margin: 0;
  }
}
</style>
